import type { IRootState } from '@store/slices';

export const selectDialogState   = (s: IRootState) => s.dialog;
export const selectDialogMode    = (s: IRootState) => s.dialog.mode;
export const selectDialogIssueId = (s: IRootState) => s.dialog.issueId;
export const selectDialogPrefill = (s: IRootState) => s.dialog.prefill;
export const selectDialogOpen    = (s: IRootState) => s.dialog.mode !== null;
export const selectDialogLinkedTask = (s: IRootState) => s.dialog.linkedTask;
